import { parsePhoneNumber } from 'libphonenumber-js';

const formatPhoneNumber = number => {
  let formatted;
  if (number) {
    try {
      const phone = parsePhoneNumber(number, 'US');
      if (phone && phone.isValid()) {
        formatted = phone.format('NATIONAL');
        formatted = formatted.replace('(', '');
        formatted = formatted.replace(') ', '-');
      } else {
        formatted = number;
      }
    } catch (e) {
      formatted = number;
    }
  }
  return formatted;
};

const registrationPayload = values => {
  const phoneFormatted = formatPhoneNumber(values.Number);
  const mobileFormatted = formatPhoneNumber(values.Mobile || '');
  const faxFormatted = formatPhoneNumber(values.FaxNumber || '');

  const payload = {
    serviceRequestId: 0,
    PersonId: 0,
    firstName: values.First,
    middleName: values.Middle,
    lastName: values.Last,
    // prefix id????
    prefixName: values.Prefix,
    suffixName: values.Suffix,
    informalSalutation: values.Informal,
    titleDescription: values.Title,
    //worksCompanyId
    company: values.Company,
    countryCode: values.CountryCode,
    country: values.Country,
    //mainAddressId
    streetAddress: values.StreetAddress1,
    suite: values.StreetAddress2 !== 'STE ' ? values.StreetAddress2 : '',
    city: values.City,
    stateCode: values.StateCode,
    postalCode: values.PostalCode,
    workPhone: phoneFormatted,
    extension: values.Extension,
    Mobile: mobileFormatted,
    FaxNumber: faxFormatted,
    EmailAddress: values.EmailAddress,
    ConfirmEmailAddress: values.ConfirmEmailAddress,
    password: values.Password,
    Comments: values.Comments,
  };
  return payload;
};
export default registrationPayload;
